/* eslint-disable */
import moment from "moment";
import "moment/locale/ja";
import logger from "@/module/Logger";

export default {
  install: (app) => {
    moment.locale("ja");
    app.config.globalProperties.$moment = moment;
    app.config.globalProperties.$logger = logger;
  },
};
